export const CONNECT_WALLET = "connect_wallet";
export const CONNECT_WALLET_CLICK = "connect_wallet_cta";
export const DISCONNECT_WALLET = "disconnect_wallet";
export const TERMS_OF_SERVICES = "terms_of_services";
export const NETWORK_SWITCHED = "network_switched";

export const APPROVE_STAKING_CLICK = "approve_staking_click";
export const APPROVE_UNSTAKING_CLICK = "approve_unstaking_click";

export const STAKE_ENTERAMOUNT = "stake_enteramount";
export const MAX_STAKE = "max_stake";
export const MAX_UNSTAKE = "max_unstake";
export const STAKE_CTA = "stake_cta";
export const UNSTAKE_CTA = "unstake_cta";
export const CLAIM_CTA = "claim_cta";
export const STAKE_SUCCESSFUL = "stake_successful";
export const STAKE_FAILED = "stake_failed";
export const UNSTAKE_SUCCESSFUL = "unstake_successful";
export const UNSTAKE_FAILED = "unstake_failed";
export const CLAIM_SUCCESSFUL = "claim_successful";
export const CLAIM_FAILED = "claim_failed";

// vault
export const VAULT_DEPOSIT_SUCCESSFUL = "vault_deposit_successful";
export const VAULT_WITHDRAW_SUCCESSFUL = "vault_withdraw_successful";
export const VAULT_CLAIM_SUCCESSFUL = "vault_claim_successful";
export const VAULT_DEPOSIT_FAILED = "vault_deposit_failed";
export const VAULT_WITHDRAW_FAILED = "vault_withdraw_failed";
export const VAULT_CLAIM_FAILED = "vault_claim_failed";
export const VAULT_LISTING_CTA = "vault_listing_cta";
export const VAULT_DEPOSIT_CLICK = "vault_deposit_click";
export const VAULT_WITHDRAW_CLICK = "vault_withdraw_click";
export const VAULT_MAX_DEPOSIT_CLICK = "vault_max_deposit_click";
export const VAULT_MAX_WITHDRAW_CLICK = "vault_max_withdraw_click";
export const VAULT_APPROVE_CLICK = "vault_approve_click";
export const VAULT_TOKEN_SELECTION = "vault_token_selection";
export const VAULT_OUTPUT_TOKEN_SELECTION = "vault_output_token_selection";
export const VAULT_CONNECT_WALLET_CLICK = "vault_connect_wallet_click";
export const VAULT_DEPOSIT_CTA = "vault_deposit_cta";
export const VAULT_WITHDRAW_CTA = "vault_withdraw_cta";

export const VAULT_DEFI_ADD_LIQUIDITY = "vault_defi_add_liquidity";

//yield vault
export const YIELD_VAULT = {
  DEPOSIT_SUCCESSFUL: "yield_vault_deposit_successful",
  WITHDRAW_SUCCESSFUL: "yield_vault_withdraw_successful",
  CLAIM_SUCCESSFUL: "yield_vault_claim_successful",
  DEPOSIT_FAILED: "yield_vault_deposit_failed",
  WITHDRAW_FAILED: "yield_vault_withdraw_failed",
  CLAIM_FAILED: "yield_vault_claim_failed",
  DEPOSIT_CLICK: "yield_vault_deposit_click",
  WITHDRAW_CLICK: "yield_vault_withdraw_click",
  MAX_DEPOSIT_CLICK: "yield_vault_max_deposit_click",
  MAX_WITHDRAW_CLICK: "yield_vault_max_withdraw_click",
  DEPOSIT_CTA: "yield_vault_deposit_cta",
  WITHDRAW_CTA: "yieldp_vault_withdraw_cta",
};

export const STABLE_VAULT = {
  DEPOSIT_SUCCESSFUL: "stable_vault_deposit_successful",
  WITHDRAW_SUCCESSFUL: "stable_vault_withdraw_successful",
  CLAIM_INITIATED: "stable_vault_claim_initiated",
  CLAIM_SUCCESSFUL: "stable_vault_claim_successful",
  DEPOSIT_FAILED: "stable_vault_deposit_failed",
  WITHDRAW_FAILED: "stable_vault_withdraw_failed",
  CLAIM_FAILED: "stable_vault_claim_failed",
  DEPOSIT_CLICK: "stable_vault_deposit_click",
  WITHDRAW_CLICK: "stable_vault_withdraw_click",
  MAX_DEPOSIT_CLICK: "stable_vault_max_deposit_click",
  MAX_WITHDRAW_CLICK: "stable_vault_max_withdraw_click",
  DEPOSIT_CTA: "stable_vault_deposit_cta",
  WITHDRAW_CTA: "stable_vault_withdraw_cta",
};

export const CRYPTANIUM_VAULT = {
  DEPOSIT_SUCCESSFUL: "cryptanium_vault_deposit_successful",
  WITHDRAW_SUCCESSFUL: "cryptanium_vault_withdraw_successful",
  CLAIM_SUCCESSFUL: "cryptanium_vault_claim_successful",
  DEPOSIT_FAILED: "cryptanium_vault_deposit_failed",
  WITHDRAW_FAILED: "cryptanium_vault_withdraw_failed",
  CLAIM_FAILED: "cryptanium_vault_claim_failed",
  DEPOSIT_CLICK: "cryptanium_vault_deposit_click",
  WITHDRAW_CLICK: "cryptanium_vault_withdraw_click",
  MAX_DEPOSIT_CLICK: "cryptanium_vault_max_deposit_click",
  MAX_WITHDRAW_CLICK: "cryptanium_vault_max_withdraw_click",
  DEPOSIT_CTA: "cryptanium_vault_deposit_cta",
  WITHDRAW_CTA: "cryptanium_vault_withdraw_cta",
};

// export const TOKENX_APPROVE_SUCCESSFUL = "tokenx_approve_successful";
// export const TOKENX_APPROVE_FAILED = "tokenx_approve_failed";

export const TOKEN_APPROVE_SUCCESSFUL = "token_approve_successful";
export const TOKEN_APPROVE_FAILED = "token_approve_failed";

export const TOKEN_SELECTION = "token_selection";
// export const ADD_RSETH = "add_rsETH";
export const ADD_TOKEN = "add_token";

export const CLICK_SUB_HEADER = "click_sub_header";
export const VIEW_ADDRESS_ON_SCANNER = "view_address_on_scanner";
export const COPY_ACCOUNT_ADDRESS = "copy_account_address";

export const WALLET_CONNECTED_SUCCESSFULLY = "wallet_connected_successfully";

// Unstake
export const UNSTAKE_ENTER_AMOUNT = "unstake_enter_amount";
//Wallet_address, token_Balance, amount_entered, current_token, chain

// stake TX modal
export const POST_DEPOSIT_DEFI_EXPLORE = "post_deposit_defi_explore";

// vault deposit mmodal
export const POST_VAULT_DEFI_EXPLORE = "post_vault_defi_explore";

// Wrap rsETH
export const APPROVE_WRAPPING_CLICK = "approve_wrapping_click";
export const APPROVE_WRAPPING_SUCCESSFUL = "approve_wrapping_successful";
export const APPROVE_WRAPPING_FAILED = "approve_wrapping_failed";
export const WRAP_UNWRAP_ENTER_AMOUNT = "wrap_unwrap_enter_amount";
export const MAX_WRAP_CLICK = "max_wrap_click";
export const MAX_UNWRAP_CLICK = "max_unwrap_click";
export const TOGGLE_WRAP_UNWRAP = "toggle_wrap_unwrap";
export const WRAP_UNWRAP_CTA = "wrap_unwrap_cta";

// Wrap rsETH
export const VAULT_APPROVE_WRAPPING = "vault_approve_wrappin";
export const VAULT_WRAP_UNWRAP_ENTER_AMOUNT = "vault_wrap_unwrap_enter_amount";
export const VAULT_MAX_WRAP_UNWRAP = "vault_max_wrap_unwrap";
export const VAULT_TOGGLE_WRAP_UNWRAP = "vault_toggle_wrap_unwrap";
export const VAULT_WRAP_UNWRAP_CTA = "vault_wrap_unwrap_cta";

// Dashboard
export const COPY_REFERRAL_LINK = "copy_referral_link";
export const KELP_GRAND_MILES_CONVERSION = "kelp_grand_miles_conversion";
export const REFERRAL_INFO = "referral_info";

// Bridge rsETH
export const BRIDGE_TO_CHAIN = "bridge_to_chain";

// Bridge agETH
export const BRIDGE_TO_CHAIN_AGETH = "bridge_to_chain_agETH";

// Claim KEP
export const CLAIM_KEP = "claim_kep";
export const CLAIM_KEP_CLICK = "claim_kep_click";
export const CLAIMABLE_EL_POINTS = "claimable_el_points";
export const FEE = "fee";

// Claim EL
export const CLAIM_EL_CTA = "claim_el_cta";
export const CLAIM_EL_SUCCESSFUL = "claim_el_successful";
export const CLAIM_EL_FAILED = "claim_el_failed";
export const CLAIM_DISCLAIMER_APPROVE = "claim_disclaimer_approve";
export const CLAIM_DISCLAIMER_REJECT = "claim_disclaimer_reject";

// Claim Scroll
export const CLAIM_SCROLL_CTA = "claim_scroll_cta";
export const CLAIM_SCROLL_SUCCESSFUL = "claim_scroll_successful";
export const CLAIM_SCROLL_FAILED = "claim_scroll_failed";

// Stader Ledger Users
export const STADER_RESTAKE_COMPLETE = "stader_restake_complete";
export const STADER_RESTAKE_FAILED = "stader_restake_failed";
export const STADER_RESTAKE_INITIATE = "stader_restake_initiate";

//Defi
export const DEFI_SELECT_CHAIN = "defi_select_chain";
export const DEFI_ADD_LIQUIDITY = "add_liquidity";
export const DEFI_SWAP = "defi_swap";
export const DEFI_WITHDRAW = "defi_withdraw";
export const DEFI_FILTERS_CHANGED = "defi_filters_changed";

// Landing page headers click
export const LP_PRODUCTS = "LP_Products";
export const LP_NETWORKS = "LP_Networks";
export const LP_AVS = "LP_AVS";
export const LP_ABOUT = "LP_About";
export const LP_INSIGHTS = "LP_Insights";
export const LP_RESOURCES = "LP_Resources";
export const LP_RESTAKE = "LP_Restake";
export const LP_GAIN = "LP_Gain";
export const LP_SUBSCRIBE = "LP_Subscribe";
export const LP_HEADER = "LP_Header"; // default
export const LP_FOOTER = "LP_FOOTER";
export const LP_SOCIAL = "LP_Social";
export const LP_INFO = "LP_INFO";
export const LP_SECURITY = "LP_Security";
export const LP_BLOGS_VIEW_MORE = "LP_Blogs_view_more";

//Dashboard Defi Nudge
export const DASHBOARD_BANNER_CLICK = "dashboard_banner_click";

//Institutions
export const INSTITUTION_GET_STARTED = "Institution_GetStarted";
export const INSTITUTION_SUBMIT = "Insititution_formSubmit";

//Bridge & wrap
export const BW_GET_RSETH = "BW_GET_RSETH";
export const BW_GET_AGETH = "BW_GET_AGETH";
// Defi Opportunities type
export const FEATURED_OPPORTUNITIES = "featured_opportunities";
export const GENERAL_OPPORTUNITIES = "general_opportunities";

// Sidebar Option Click
export const LEFTNAV_OPTION_CLICK = "leftnav_option_click";
export const LEFTNAV_SOCIAL_MEDIA = "leftnav_social_media";
export const LEFTNAV_DOCS = "leftnav_docs";

//Unstake gain nudge - KSP-214
export const UNSTAKE_GAIN_NUDGE = "unstake_gain_nudge";

//Claim gain nudge - KSP-221
export const CLAIM_GAIN_NUDGE = "claim_gain_nudge";
export const RESTAKE_SIDEBAR_GAIN = "restake_gain_sidebar";
export const POST_CLAIM_MODAL_VAULT_PROMPT = "post_claim_modal_vault_prompt";

export const MINT_LIMIT_CROSSED = "mint_limit_crossed";

// Vault Card Click
export const CLICK_VAULT_CARD = "click_vault_card";
export const VAULT_PERFORMANCE_TIMEFRAME_CHANGE =
  "vault_performance_timeframe_change";
export const VAULT_PORTFOLIO_TAB_CHANGE = "vault_portfolio_tab_change";
export const VAULT_DWB_TAB_CHANGE = "vault_dwb_tab_change";

// New events from tracking table
export const CONFIRM_TRANSACTIONS = "confirm_transactions";
export const DROPDOWN_OPTIONS_CLICKED = "dropdown_options_clicked";
export const DAPP_TO_VAULT = "dapp_to_vault";
export const WITHDRAWAL_QUEUE_SIGNUP = "withdrawal_queue_signup";
export const VIEW_TRANSACTION = "view_transaction";
export const STARTEGY_REPORT_TIMERANGE_CHANGED =
  "startegy_report_timerange_changed";
export const PRODUCT_DROPDOWN_CTA = "product_dropdown_cta";
export const LP_PRODUCT_CTA_CLICK = "lp_product_cta_click";
export const LP_RESTAKE_WIDGET_CLICK = "lp_restake_widget_click";
export const EMAIL_SIGNUP = "email_signup";
export const HEADER_NAV_CLICK = "header_nav_click";
export const STRATEGY_CONTRACT_HYPERLINK_CLICK =
  "strategy_contract_hyperlink_click";
export const GAIN_DEFI_CLICKS = "gain_defi_clicks";

// Vault Disclaimer
export const VAULT_DISCLAIMER_CLICKED = "vault_disclaimer_clicked";

// Post Transaction Popup
export const POST_TRANSACTION_POPUP = "post_transaction_popup";

// Unwrap Events
export const UNWRAP_INITIATED = "unwrap_initiated";
export const UNWRAP_FAILED = "unwrap_failed";
export const UNWRAP_SUCCESSFUL = "unwrap_successful";

// Wrap Events
export const WRAP_INITIATED = "wrap_initiated";
export const WRAP_FAILED = "wrap_failed";
export const WRAP_SUCCESSFUL = "wrap_successful";

// Vault Max Selected
export const VAULT_MAX_SELECTED = "vault_max_selected";

// Banner Clicked
export const BANNER_CLICKED = "banner_clicked";

// Bridge Events
export const BRIDGE_CHAIN_SELECTED = "bridge_chain_selected";
export const GO_TO_BRIDGE = "go_to_bridge";

// Learn More
export const LEARN_MORE_CLICK = "learn_more_click";

// DeFi Opportunities
export const TOP_OPPORTUNITIES_SCROLLED = "top_opportunities_scrolled";
export const DEFI_OPPORTUNITIES_SORTED = "defi_opportunities_sorted";

// Claims
export const CLAIMS_TABS_CHANGED = "claims_tabs_changed";
export const CLAIM_DISCLAIMER_VIEWED = "claim_disclaimer_viewed";
export const CLAIM_DISCLAIMER_APPROVED = "claim_disclaimer_approved";
export const VIEW_STAKED_KERNEL = "view_staked_kernel";

// Referral
export const REFERRAL_LINK_COPIED = "referral_link_copied";
